<template>
  <content-container>
    <div class="not-available">
      <p>{{ displayedMessage }}</p>
      <p>¯\_(ツ)_/¯</p>
    </div>
    <page-contact-menu />
  </content-container>
</template>

<script>
import ContentContainer from '@/components/common/main-layout/content-container'
import PageContactMenu from '@/components/common/navigation/page-contact-menu'
const messages = ['Će bude!', 'Ništa mi tu nismo dirali...', 'Ovo nisu droidi koje tražiš... ✋', 'The end is nigh...', '']
export default {
  name: 'support-placeholder',
  components: { PageContactMenu, ContentContainer },
  computed: {
    displayedMessage () {
      const rndNumber = Math.floor(Math.random() * 5)
      return messages[rndNumber]
    }
  }
}
</script>

<style scoped lang="scss">
.not-available {
  text-align: center;
  padding: 3rem 2rem;
  color: $text;
  border: 1px dashed $dark-grey;
  border-radius: 5px;
  max-width: 640px;
  margin: 10% auto;

p {
  margin-bottom: 1rem;
}
}
</style>
